module.exports = __webpack_public_path__ + "img/TL.a5e72469.png";